import React, { Dispatch, SetStateAction, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectOrganization } from "go-security/services/organizations/selectors";
import {
	DeliveryEstimationApi,
	LiveOrderApi,
} from "../../../../../../../../../../../../services/Api/Organization/types";
import { isWoltDriveAssigned } from "../../../../../../services/orderDelivery";
import { LiveOrderDeliveryOptionType } from "../../../../../../services/types";
import { checkIfDeliveryOptionIsDisabled, isWoltDriveEnabled } from "../../../../../../services/utils";
import { useEstimateDelivery } from "../../hooks/useEstimateDelivery";
import LiveOrderDeliveryOption from "../LiveOrderDeliveryOptions/LiveOrderDeliveryOption";

interface Props {
	order: LiveOrderApi;
	orderDate: string | undefined;
	setFirstEstimatedDeliveryData: React.Dispatch<React.SetStateAction<DeliveryEstimationApi | undefined>>;
	firstEstimatedDeliveryData: DeliveryEstimationApi | undefined;
	setEstimatedDeliveryData: (data: DeliveryEstimationApi | undefined) => void;
	estimatedDeliveryData: DeliveryEstimationApi | undefined;
	setSelectedDeliveryOption: (option: LiveOrderDeliveryOptionType | undefined) => void;
	selectedDeliveryOption: LiveOrderDeliveryOptionType | undefined;
	handleToggle: (option?: LiveOrderDeliveryOptionType) => void;
	orderEstimatedPreparationInMinutes?: number;
	selectedTimeOption: number | undefined | string;
	estimatingLoading: boolean;
	setEstimatingLoading: Dispatch<SetStateAction<boolean>>;
}

const LiveOrderAssignDeliveryEmployeeModalDeliveryOptions = ({
	order,
	orderDate,
	setFirstEstimatedDeliveryData,
	firstEstimatedDeliveryData,
	setEstimatedDeliveryData,
	estimatedDeliveryData,
	setSelectedDeliveryOption,
	selectedDeliveryOption,
	handleToggle,
	orderEstimatedPreparationInMinutes,
	selectedTimeOption,
	estimatingLoading,
	setEstimatingLoading,
}: Props) => {
	const organization = useSelector(selectOrganization);
	const isWoltDrive = isWoltDriveAssigned(order);
	const woltDriveEnabled = isWoltDriveEnabled(organization);
	const { handleEstimateDelivery, isOutOfDeliveryZone } = useEstimateDelivery({
		orderId: order.id,
		setEstimatedDeliveryData,
		setEstimatingLoading,
	});

	useEffect(() => {
		if (woltDriveEnabled && !isWoltDrive) handleInit(orderDate);
	}, []);

	const handleInit = async (data?: string) => {
		const res = await handleEstimateDelivery(data);
		setFirstEstimatedDeliveryData(res);
	};

	const getDeliveryOptions = () => {
		const options = [LiveOrderDeliveryOptionType.OWN_DRIVER];
		if (woltDriveEnabled && order && order.status !== "EXTERNAL")
			options.push(LiveOrderDeliveryOptionType.WOLT_DRIVE);

		return options;
	};

	if (!woltDriveEnabled) return <></>;

	return (
		<>
			<div className="d-flex flex-wrap gap-3 live-order-delivery-options">
				{getDeliveryOptions().map((deliveryOption) => (
					<LiveOrderDeliveryOption
						option={deliveryOption}
						key={deliveryOption}
						setSelectedDeliveryOption={setSelectedDeliveryOption}
						selectedDeliveryOption={selectedDeliveryOption}
						estimatingLoading={
							deliveryOption === LiveOrderDeliveryOptionType.WOLT_DRIVE ? estimatingLoading : undefined
						}
						estimatedDeliveryData={
							deliveryOption === LiveOrderDeliveryOptionType.WOLT_DRIVE
								? estimatedDeliveryData
								: undefined
						}
						disabled={checkIfDeliveryOptionIsDisabled(
							deliveryOption,
							isWoltDrive,
							isOutOfDeliveryZone,
							order
						)}
						isOutOfDeliveryZone={isOutOfDeliveryZone}
						handleToggle={handleToggle}
						orderEstimatedPreparationInMinutes={orderEstimatedPreparationInMinutes}
						deliveryMoney={order?.delivery_cost}
						selectedTimeOption={selectedTimeOption}
						firstEstimatedDeliveryData={firstEstimatedDeliveryData}
					/>
				))}
			</div>
			{selectedDeliveryOption && <hr />}
		</>
	);
};

export default LiveOrderAssignDeliveryEmployeeModalDeliveryOptions;
